import React from 'react';
import StickyNotesBoard from '../StickyNotes/StickyNotesBoard';
import { toShippingCommentNotes } from '../StickyNotes/shippingCommentNotes';
import '../StickyNotes/StickyNotes.css';

/**
 * Sticky notes column inside the order modal.
 * Same sections as the grid editor (permanent, shipping, extra), with every
 * comment open. Adds and edits go through the same handlers as the grid column.
 */
export default function OrderNotesPanel({
    customerName,
    orderNumber,
    pinned = [],
    shippingComments = '',
    notes = [],
    customerId = null,
    onAddShipping,
    onUpdateShipping,
    onRemoveShipping,
    onAdd,
    onUpdate,
    onRemove,
}) {
    const shipping = toShippingCommentNotes(shippingComments);

    return (
        <aside className="order-popup-notes-box" aria-label="Sticky notes">
            <StickyNotesBoard
                embedded
                orderNumber={orderNumber || 'order'}
                label={orderNumber}
                customerName={customerName}
                notes={notes}
                pinned={pinned}
                shippingComments={shipping}
                canAddShipping={Boolean(customerId && onAddShipping)}
                onAddShipping={(fields) => onAddShipping(customerId, fields)}
                onUpdateShipping={(note, changes) => onUpdateShipping(note, changes)}
                onRemoveShipping={(note) => onRemoveShipping(note)}
                onAdd={(fields) => onAdd?.(orderNumber, fields)}
                onUpdate={(note, changes) => onUpdate?.(orderNumber, note, changes)}
                onRemove={(note) => onRemove?.(orderNumber, note)}
            />
        </aside>
    );
}
